import { Injectable } from '@angular/core';
import { Observable ,  of ,  BehaviorSubject } from 'rxjs';
import { GoogleLoginProvider } from 'angularx-social-login';
import { AuthService } from 'angularx-social-login';
import { DataService } from './core/data.service';
import { AuthorisationDetails } from './core/AuthorisationDetails';


@Injectable()
export class CustomAuthService {
  public loggedIn = new BehaviorSubject<boolean>(false);
  loggedInStream$ = this.loggedIn.asObservable();

  public isAdmin = new BehaviorSubject<boolean>(false);
  isAdminStream$ = this.isAdmin.asObservable();

  public kennelSid = new BehaviorSubject<number>(null);
  kennelSidStream$ = this.kennelSid.asObservable();

  public userName = new BehaviorSubject<string>(null);
  userNameStream$ = this.userName.asObservable();

  public userPic = new BehaviorSubject<string>(null);
  userPicStream$ = this.userPic.asObservable();

  public bookingData = null;
  authDetails: AuthorisationDetails;

  // store the URL so we can redirect after logging in
  redirectUrl: string;


  constructor (
      private dataService: DataService, private authService: AuthService) {
  }

  isLoggedIn(): boolean {
    return this.loggedIn.getValue();
  }

  getUserSid(): number {
    return this.authDetails.sid;
  }


  getCustomerSid(): number {
    return this.authDetails && this.authDetails.customerSid ? this.authDetails.customerSid : null;
  }

  loginWithAuthorities(authDetails: AuthorisationDetails): void {
    this.authDetails = authDetails;
    this.isAdmin.next(authDetails.isAdmin);
    this.kennelSid.next(authDetails.kennelSid);
    this.userName.next(authDetails.name);
    this.userPic.next(authDetails.pictureURL);
    this.loggedIn.next(true);
  }

  login(): Observable<boolean> {
    this.loggedIn.next(true);
    return of(true); // .do(val => this.loggedIn.next(true));
  }

  logout(): void {
      this.dataService.callPut('authenticate/logout', '').subscribe(
          (details) => {
              console.log('Logged Out: ' + details);
              localStorage.removeItem('loggedIn');
          },
          (error) => {
              // console.log('Failed to logout: ' + JSON.parse(error._body).message);
              console.log('Failed to logout: ');
          });
      this.loggedIn.next(false);
      this.isAdmin.next(false);
      localStorage.removeItem('loggedIn');
  }


  public signInWithGoogle () {
    const socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    this.authService.signIn(socialPlatformProvider).then(
        (userData) => {
          this.sendToRestApiMethod(userData.idToken);
        }
    );
  }

  sendToRestApiMethod(token: string): void {
    // this.dataService.callPostNoAuth('authenticate', JSON.stringify(token)).subscribe(
    this.dataService.callGetAuthenticate('authenticate', JSON.stringify(token)).subscribe(
        (details) => {
          this.loginWithAuthorities(details);
        },
        (error) => {
          console.log('Failed to authenticate: ' + JSON.parse(error._body).message); });
  }


  sendToRestApiMethodDevMode(userId: string): void {
    this.dataService.callGetAuthenticate('authenticate', userId).subscribe(
        (details) => {
          console.log('details', details);
          localStorage.setItem('loggedIn', userId);
          this.loginWithAuthorities(details);
        },
        (error) => {
          console.log('Failed to authenticate: ' + error); });
  }

  updateBookingData(data): void {
        this.bookingData = data;
  }

  getBookingData() {
      return this.bookingData;
  }

}
